/**
 * @typedef { '--primary-pink-hex' |
*  '--primary-pink-rgb' |
*  '--red-shade-1-hex' |
*  '--red-shade-1rgb' |
*  '--event-form-max-width' |
*  '--disabled-white-rgba' |
*  '--light-grey-1-rgb' |
*  '--light-grey-2-hex' |
*  '--light-grey-2-rgb' |
*  '--bg-dark-grey-1-hex' |
*  '--bg-dark-grey-1-rgb' |
*  '--bg-dark-grey-2-hex' |
*  '--bg-dark-grey-2-rgb' |
*  '--bg-theme-rgb' |
*  '--back-shade-2-hex' |
*  '--black-shade-2-rgb' |
*  '--black-shade-2-hex' |
*  '--black-shade-2-rgb' |
*  '--font-rgb' |
*  '--white-rgb' |
*  '--primary-green-hex' |
*  '--primary-green-rgb' |
*  '--primary-green-shade2-hex' |
*  '--primary-green-shade2-rgb' |
*  '--primary-green-text-hex' |
*  '--primary-green-text-rgb' |
*  '--primary-red-hex' |
*  '--primary-red-rgb' |
*  '--primary-blue-hex' |
*  '--primary-blue-rgb' |
*  '--primary-blue-shade2-hex' |
*  '--primary-blue-shade2-rgb' |
*  '--dark-blue-1-hex' |
*  '--dark-blue-1-rgb' | '--primary-yellow-hex'
* } CssVariableName
*/

import { hexRegex, rgbRegex } from "../regex/colorRegex";

/**
* Get the value of a CSS variable
*
* @param {Object} params
* @param {CssVariableName} params.variableName
* @returns {string} The value of the CSS variable.
*/
const getCssVariableHandler = ({ variableName }) => {
  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(variableName);
};

const getRGBAFromColor = ({ alpha, color }) => {
  if (rgbRegex.test(color)) {
    // Convert RGB to RGBA
    return color.replace(/rgb/i, "rgba").replace(/\)/i, `, ${alpha})`);
  } else if (hexRegex.test(color)) {
    // Convert HEX to RGBA
    let hex = color.substring(1);
    if (hex.length === 3) {
      hex = hex.split("").map((char) => char + char).join(""); // Convert #RGB to #RRGGBB
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
    throw new Error("Invalid color format");
  }
};

export { getCssVariableHandler, getRGBAFromColor };
